<div class="nav-button p-4" routerLinkActive="active" routerLink="/{{link}}">
    <mat-icon>{{ icon }}</mat-icon>
    <div class="label">{{ label }}</div>

    @if (label === 'Settings' && saasFeatureBadgeEnabled()) {
        <app-saas-new-feature-badge [isOldTheme]="true"></app-saas-new-feature-badge>
    }
</div>

